import "./App.css";

import Home from "./pages/Home";
import About from "./pages/About";
import Space from "./pages/Space";
import Blog from "./pages/Blog";
import NavBar from "./components/navbar/NavBar";
import AppBar from "@mui/material/AppBar";
import { Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import StickyCTA from "./components/StickyCTA";
import Ingredient from "./pages/Ingredient";
import IngredientDetail from "./pages/IngredientDetail";
import ContactFooter from "./components/contact/ContactFooter";
import Menu from "./pages/Menu";
import Error from "./subPages/Error";
import EmailSubscribe from "./components/EmailSubscribe";
import { useSelector } from "react-redux";
const USE_BLOG_SLUG = process.env.REACT_APP_USE_BLOG_SLUG === "TRUE";
const USE_INGREDIENT_SLUG =
  process.env.REACT_APP_USE_INGREDIENT_SLUG === "TRUE";

function App() {
  const language = useSelector((state) => state.reducer.language);
  return (
    <div className="App">
      <StickyCTA />
      <AppBar style={{ backgroundColor: "transparent" }} elevation={0}>
        <NavBar language={language} />
      </AppBar>
      <div className="app-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="space" element={<Space />} />
          <Route path="blog" element={<Blog />} />
          <Route
            path={USE_BLOG_SLUG ? "blog/:slug" : "blog/:id"}
            element={<BlogDetail />}
          />
          <Route path="ingredient" element={<Ingredient />} />
          <Route
            path={USE_INGREDIENT_SLUG ? "ingredient/:slug" : "ingredient/:id"}
            element={<IngredientDetail />}
          />
          <Route path="contact" element={<Contact />} />
          {process.env.REACT_APP_SHOW_MENU === "TRUE" && (
            <Route path="menu" element={<Menu />} />
          )}
          <Route path="/*" element={<Error />} />
        </Routes>
        <ContactFooter language={language} />
        {process.env.REACT_APP_SHOW_EMAIL_SUBSCRIBE === "TRUE" && (
          <EmailSubscribe />
        )}
        <Footer />
      </div>
    </div>
  );
}

export default App;
